export default __webpack_public_path__ + "static/media/logo.1fad0a6f.png";